'use es6';

export function fetch(query = {}, httpClient) {
  return httpClient.get('content/api/v4/contents/linkable-content', {
    query
  });
}